import { render } from "./Dashboard.vue?vue&type=template&id=f55a4a9a&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__